import { PageId } from '../../../constants';
import { BaseAddPage } from './base-add-page';
import { EditorScriptApi } from '../../../api/api';
import { isServicePageInstalled } from '../../editor-sdk-actions';

export class AddServicePage extends BaseAddPage {
  constructor(
    protected editorSDK,
    protected appToken,
    protected instance,
    private editorScriptApi: EditorScriptApi,
  ) {
    super(editorSDK, appToken, instance);
  }

  public async shouldAddPage(): Promise<boolean> {
    const servicePageInstalled = await isServicePageInstalled(this.editorSDK);

    return !servicePageInstalled;
  }

  public async execute() {
    try {
      await this.addBookingsPage(PageId.BOOKINGS_SERVICE_PAGE);
    } catch (e) {
      const errorMessage = `${
        e?.message ? e.message : JSON.stringify(e)
      } - errorCode: ADD_BOOKINGS_PAGES - ${PageId.BOOKINGS_SERVICE_PAGE}`;
      throw new Error(errorMessage);
    }

    await this.createPageState(PageId.BOOKINGS_SERVICE_PAGE, 'servicePage');
  }

  protected get widgetId() {
    return 'a91a0543-d4bd-4e6b-b315-9410aa27bcde';
  }

  public get widgetName() {
    return 'AddServicePage';
  }

  public get stepTranslate() {
    return 'service-page-migration.progress-bar.step-1';
  }
}
